/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import L from "./Lang"
import BaseCom from "./BaseCom";
import Icon from "./Icon";
import './ImageGalleryOverlay.css';
import { Pop } from "./PopModal";

export const ImageGalleryOverlayGlobal = {
    show: (images, onDelete) => { },
    hide: () => { }
}

export class ImageGalleryOverlay extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            selectedImage: null,
            selectedImageIndex: 0
        };
        ImageGalleryOverlayGlobal.show = this.show;
        ImageGalleryOverlayGlobal.hide = this.hide;
    }

    componentDidMount() {
        this.defaultSelectedImage();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.images !== prevState.images) {
            this.defaultSelectedImage(this.state.images);
        }
    }

    show = (images, onDelete) => {
        this.onDelete = onDelete;
        this.setState({ images: images, show: true, onDelete: onDelete });
        this.defaultSelectedImage(images);

    }

    hide = () => {
        this.setState({ show: false });
    }

    defaultSelectedImage = (images) => {
        if (!images || images.length === 0)
            return null;
        this.setState({ selectedImage: images[0], selectedImageIndex: 0 });
    }

    prevImage = () => {
        let index = this.state.selectedImageIndex - 1;
        if (index < 0) index = this.state.images.length - 1;
        this.setState({ selectedImage: this.state.images[index], selectedImageIndex: index });
    }

    nextImage = () => {
        let index = this.state.selectedImageIndex + 1;
        if (index >= this.state.images.length) index = 0;
        this.setState({ selectedImage: this.state.images[index], selectedImageIndex: index });
    }

    hasNext = () => {
        return this.state.selectedImageIndex < this.state.images.length - 1;
    }

    hasPrev = () => {
        return this.state.selectedImageIndex > 0;
    }

    deleteImage = () => {
        Pop.showConfirm('Delete Image', 'Are you sure you want to delete this image?', () => {
            let images = this.state.images;
            images.splice(this.state.selectedImageIndex, 1);
            this.setState({ images: images });
            this.defaultSelectedImage(images);
            this.onDelete?.(images, this.state.selectedImageIndex);
            if (images.length === 0)
                this.hide();
        });
    }

    render() {
        if (!this.state.show) return;

        return <div className="image-gallery-overlay no-select">
            <div className="image-gallery-overlay__close" onClick={this.hide}><L>X</L></div>
            {this.hasNext() && <div className="image-gallery-overlay__next" onClick={this.nextImage}><L>&gt;</L></div>}
            {this.hasPrev() && <div className="image-gallery-overlay__prev" onClick={this.prevImage}><L>&lt;</L></div>}
            <div className="image-gallery-overlay__counter">{this.state.selectedImageIndex + 1} of {this.state.images.length}</div>
            {this.state.onDelete && <div className="image-gallery-overlay__delete" onClick={this.deleteImage}><Icon icon="faTrash" /></div>}
            <img src={this.state.selectedImage.url} alt="gallery" className="image-gallery-overlay__img img-fluid" />
        </div>;
    }
}